// removed by extract-text-webpack-plugin
module.exports = {"modal":"_2DIOf","modalCard":"_3zE4N"};


//////////////////
// WEBPACK FOOTER
// ./app/components/TutorSignupForm/modalTheme.scss
// module id = 1639
// module chunks = 14